var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossClipboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.8356 3.836C11.7706 4.046 11.7356 4.269 11.7356 4.5C11.7356 4.914 12.0716 5.25 12.4856 5.25H16.9856C17.1845 5.25 17.3753 5.17098 17.5159 5.03033C17.6566 4.88968 17.7356 4.69891 17.7356 4.5C17.7357 4.27491 17.702 4.05109 17.6356 3.836M11.8356 3.836C11.9776 3.3767 12.263 2.97493 12.6499 2.68954C13.0367 2.40414 13.5048 2.25011 13.9856 2.25H15.4856C16.4976 2.25 17.3526 2.918 17.6356 3.836M11.8356 3.836C11.4596 3.859 11.0856 3.886 10.7116 3.916C9.5806 4.01 8.7356 4.973 8.7356 6.108V8.25M17.6356 3.836C18.0116 3.859 18.3856 3.886 18.7596 3.916C19.8906 4.01 20.7356 4.973 20.7356 6.108V16.5C20.7356 17.0967 20.4985 17.669 20.0766 18.091C19.6546 18.5129 19.0823 18.75 18.4856 18.75H16.2356M8.7356 8.25H5.3606C4.7396 8.25 4.2356 8.754 4.2356 9.375V20.625C4.2356 21.246 4.7396 21.75 5.3606 21.75H15.1106C15.7316 21.75 16.2356 21.246 16.2356 20.625V18.75M8.7356 8.25H15.1106C15.7316 8.25 16.2356 8.754 16.2356 9.375V18.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.38574 16.8L11.9857 13.2M8.38574 13.2L11.9857 16.8",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCrossClipboard;